<template>
    <div>
        <Mapa
            v-if="markersValidos.length > 0"
            :center="centerMapa"
            :markers="markersValidos"
            :icon="icon"
            height="380px;"
            botaoimprimir="none"
            :loadHome="true"
        />

        <div class="text-center my-5" v-else>
            <img
                :alt="$t('No results')"
                class="mb-5"
                src="/img/icons/robot.svg"
                style="max-height: 165px"
            />
            <h3 class="bold">{{ $t("No records found") }}</h3>
        </div>
    </div>
</template>

<script>
import Mapa from "@modules/Mapa/Resources/assets/js/includes/Mapa";

export default {
    components: { Mapa },

    props: {
        markers: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            loading: false,
            tipo: "familias_cadastradas",
            icon: window.urlbase + "img/icons/map/home-plus.svg",
        };
    },

    computed: {
        markersValidos() {
            if (!Array.isArray(this.markers)) {
                return [];
            }

            return this.markers.filter((item) => {
                const lat = Number(item.lat);
                const lng = Number(item.lng);

                return Number.isFinite(lat) && Number.isFinite(lng);
            });
        },

        centerMapa() {
            const latCidade = Number(this.$store.state.settings.app_cidade_lat);
            const lngCidade = Number(this.$store.state.settings.app_cidade_lng);

            if (Number.isFinite(latCidade) && Number.isFinite(lngCidade)) {
                return {
                    lat: latCidade,
                    lng: lngCidade,
                };
            }

            const primeiroValido = this.markersValidos[0];

            if (primeiroValido) {
                return {
                    lat: Number(primeiroValido.lat),
                    lng: Number(primeiroValido.lng),
                };
            }

            return {
                lat: -23.55052,
                lng: -46.633308,
            };
        },
    },
};
</script>